(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1492],{

/***/ 8154:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/the-brand/[path]",
      function () {
        return __webpack_require__(15157);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; },
/* harmony export */   "pageId": function() { return /* binding */ pageId; },
/* harmony export */   "pagePathView": function() { return /* binding */ pagePathView; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96204);
/* harmony import */ var client_components_Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3066);
/* harmony import */ var src_pages_builder_builderUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64972);





(0,src_pages_builder_builderUtils__WEBPACK_IMPORTED_MODULE_4__/* .registerBuilderComponents */ .l)();
var pagePathView = "/the-brand/[path]";
var pageId = "corporate";
var __N_SSP = true;
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(props) {
    var builderContent = props.builderContent, config = props.config;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_builder_io_react__WEBPACK_IMPORTED_MODULE_2__/* .BuilderComponent */ .VD, {
                locale: config.locale,
                model: "page",
                content: builderContent
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_Footer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
        ]
    });
};



/***/ }),

/***/ 64972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ registerBuilderComponents; }
/* harmony export */ });
/* unused harmony export getBuilderPageContent */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50853);
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96204);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_constants_subscriptionSources__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4077);





var getBuilderPageContent = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(url, locale) {
        var builderContent;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* .builder.get */ .fl.get("page", {
                            url: url,
                            options: {
                                locale: locale
                            },
                            userAttributes: {
                                locale: locale
                            },
                            includeUnpublished: true
                        }).toPromise()
                    ];
                case 1:
                    builderContent = _state.sent();
                    return [
                        2,
                        builderContent
                    ];
            }
        });
    });
    return function getBuilderPageContent(url, locale) {
        return _ref.apply(this, arguments);
    };
}();
var registerBuilderComponents = function() {
    // Factorial open positions component
    _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent(next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
        return __webpack_require__.e(/* import() */ 9365).then(__webpack_require__.bind(__webpack_require__, 59365));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(59365)
                ];
            }
        }
    }), {
        name: "FactorialOpenPositions",
        inputs: [
            {
                name: "width",
                type: "string",
                defaultValue: "100%"
            },
            {
                name: "height",
                type: "string",
                defaultValue: "100%"
            }, 
        ]
    });
    // external link
    _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent((0,_builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* .withChildren */ .u7)(next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
        return __webpack_require__.e(/* import() */ 1933).then(__webpack_require__.bind(__webpack_require__, 41933));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(41933)
                ];
            }
        }
    })), {
        name: "LinkBlock",
        inputs: [
            {
                name: "url",
                type: "string",
                defaultValue: ""
            },
            {
                name: "target",
                type: "string",
                defaultValue: "_self",
                enum: [
                    "_self",
                    "_blank",
                    "_parent",
                    "_top"
                ]
            }, 
        ]
    });
    _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent(next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 24953)).then(function(module) {
            return module.SubscriptionBox;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(24953)
                ];
            }
        }
    }), {
        name: "NewsletterBox",
        inputs: [
            {
                name: "source",
                type: "string",
                defaultValue: src_constants_subscriptionSources__WEBPACK_IMPORTED_MODULE_4__/* .SUBSCRIPTION_BOX_LANDINGS_PAGE */ .aE,
                localized: true
            },
            {
                name: "variant",
                type: "text",
                enum: [
                    "box",
                    "section",
                    "minimal"
                ],
                defaultValue: "section",
                helperText: "box/section: Full customization. minimal: Only input + button (no title/description/background)"
            },
            {
                name: "title",
                type: "string",
                localized: true,
                showIf: 'options.get("variant") !== "minimal"',
                helperText: "Custom title (uses default translation if empty)"
            },
            {
                name: "description",
                type: "string",
                localized: true,
                showIf: 'options.get("variant") !== "minimal"',
                helperText: "Custom description (uses default translation if empty)"
            },
            {
                name: "bgColor",
                type: "color",
                defaultValue: "#B494F9",
                showIf: 'options.get("variant") !== "minimal"',
                helperText: "Container background color"
            },
            {
                name: "buttonText",
                type: "string",
                localized: true,
                helperText: "Custom button text (uses default translation if empty)"
            },
            {
                name: "buttonBgColor",
                type: "color",
                helperText: "Custom button background color (uses default if empty)"
            },
            {
                name: "buttonTextColor",
                type: "color",
                helperText: "Custom button text color (uses default if empty)"
            }, 
        ]
    });
    _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent((0,_builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* .withChildren */ .u7)(next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 24953)).then(function(module) {
            return module.BannerProperties;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(24953)
                ];
            }
        }
    })), {
        name: "BannerProperties",
        inputs: [
            {
                name: "bannerId",
                type: "string",
                defaultValue: ""
            },
            {
                name: "checkInOffset",
                type: "number",
                defaultValue: 0,
                min: 0,
                helperText: "Number of days to add to the check-in date from today (TTC)"
            }, 
        ]
    });
    _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent(next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 24953)).then(function(module) {
            return module.TopDestinations.Connected;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(24953)
                ];
            }
        }
    }), {
        name: "BannerDestinations",
        inputs: [
            {
                name: "bannerId",
                type: "string",
                defaultValue: ""
            }
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(8154); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);